import { DatePipe } from '@angular/common'
import {
  Component,
  Input,
  TemplateRef,
  ViewChild,
  ViewContainerRef,
} from '@angular/core'
import { Subscription } from 'rxjs'
import { CentralContentService } from 'src/app/services/content/central-content.service'
import { CookieService } from 'src/app/services/cookie/cookie.service'

import { Overview } from '../../overview.model'

@Component({
  selector: 'key-facts',
  templateUrl: './key-facts.component.html',
  styleUrls: ['./key-facts.component.scss'],
  providers: [],
})
export class KeyFactsComponent {
  @ViewChild('simpleDialogContent', { static: false })
  public simpleDialogContent: TemplateRef<any>
  @Input()
  overviewModel: Overview
  datePipe: any
  iovTickerSymbol: string
  retail: string
  government: string
  cookie: any
  internal: boolean
  aemContentSub: Subscription
  dialogTitle: string
  dialogBody: string

  constructor(
    private readonly viewContainer: ViewContainerRef,
    private readonly centralContentService: CentralContentService,
    private readonly cookieService: CookieService,
  ) {
    this.datePipe = new DatePipe('en-US')
  }

  ngOnInit() {
    this.aemContentSub = this.centralContentService.aemContent$.subscribe(
      (content) => {
        this.parseAEMContent(content)
      },
    )
    this.getInternal()
  }

  parseAEMContent(content) {
    this.iovTickerSymbol = this.centralContentService.getContentByBody(
      'fund_definitions_iov_ticker_symbol',
      content,
    ).contentValue
    this.retail = this.centralContentService.getContentByBody(
      'fund_definitions_retail',
      content,
    ).contentValue
    this.government = this.centralContentService.getContentByBody(
      'fund_definitions_government',
      content,
    ).contentValue
  }

  public setDialogInfo(title: string) {
    this.dialogTitle = title
    if (this.dialogTitle === 'Retail') {
      this.dialogBody = this.retail
    } else if (this.dialogTitle === 'Government Money Market Funds') {
      this.dialogBody = this.government
    } else if (this.dialogTitle === 'Intraday optimized value ticker') {
      this.dialogBody = this.iovTickerSymbol
    }
  }
  getInternal() {
    this.cookieService.isInternalSession().subscribe((response) => {
      this.internal = response === 'true'
    })
  }
}
